angular.module('homebot.directives')

  .directive('homeInviteForm', ['DataService', 'HelperService', 'UtilService', 'PageNotificationService', function(DataService, helpers, utils, PageNotificationService){
    return {
      controllerAs: 'ctrl',
      bindToController: {
        userId: '@',
        agentId: '@'
      },
      restrict: 'E',
      scope: {},
      templateUrl: '/homes/templates/ho-invite.html',
      controller: function(){
        var ctrl = this;

        var onSave = function(invite){
            PageNotificationService.success(`An invitation has been sent to ${ctrl.invite.firstName} ${ctrl.invite.lastName}.`);
            ctrl.loading = false;
            ctrl.invite = {};
          };

        var onError = function(errorMsg){
            ctrl.error = errorMsg;
            ctrl.loading = false;
          };

        ctrl.addInvite = function(){
          var invite = {
            firstName: ctrl.invite.firstName,
            lastName: ctrl.invite.lastName,
            email: ctrl.invite.email,
            inviterId: ctrl.userId,
            agentId: ctrl.agentId
          };

          ctrl.loading = true;

          DataService.addInvite(invite)
            .then(onSave)
            .catch(onError);

          utils.track('InviteAnotherHomeowner');
        };
      }
    };
  }]);
